import React, { Component } from 'react'

import './slide.css'

class AdvanceButton extends Component {

  handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClick();
  }

  render () {
    let arrow = (this.props.pointsLeft) ? '<' : '>';
    let style = null;

    if (this.props.isVisible) {
      style = {
        backgroundColor: 'white',
        color: 'black',
      }
    }

    return (
      <div style = {style} className="advance-button" onClick = {this.handleClick}>
        <div className="arrow-container">
          {arrow}
        </div>
      </div>
    );
  }
}


export default {AdvanceButton}



// WEBPACK FOOTER //
// ./src/components/Slide/advance-button.js